module.exports = __webpack_public_path__ + "img/Gefahr_durch_Luftmangel.92a9b5a0.svg";